const has = require('lodash/fp/has');
const map = require('lodash/fp/map');
const merge = require('lodash/fp/merge');
const defaultParsePosition = require('./parse-position');
const defaultParseTransaction = require('./parse-transaction');
const defaultParseValueMovement = require('./parse-value-movement');
const memoizer = require('../request-handler/utils/memoizer');

/**
 * Assets Service Factory
 * @param {Object} config - config
 * @param {Function} config.api - API as provided by './api-factory'
 * @param {Object} config.commonQS - An object of query parameters added to every request
 * @param {Function} [config.parsePosition] - Fn to parse the API’s position response object
 * @param {Function} [config.parseTransaction] - Fn to parse the API’s transaction object
 * @param {Function} [config.parseValueMovement] - Fn to parse the API’s valueMovement object
 * @returns {Object} - The service { getPositions, getValueMovement, getTransactions }
 */

function addDataIndex(data){
  
  for (var i = 0; i < data.length; i++) {
    data[i].index = i;
  }

  return data;
}

function serviceFactory({
  api,
  parsePosition = defaultParsePosition,
  parseTransaction = defaultParseTransaction,
  parseValueMovement = defaultParseValueMovement,
}) {
  const getPositionsLength = memoizer()((portfolioId, metaData) =>
    api.getPositions(portfolioId, metaData)
      .then(positions => positions.length));



  const getPositions = memoizer()((portfolioId, metaData, posId) =>
    api.getPositions(portfolioId, metaData, posId)
      .then(map(parsePosition))
      .then(addDataIndex)
    );



      
      
  const getValueMovement = memoizer()((portfolioId, positionIndex, metaData, posId) =>
    getPositions(portfolioId, metaData, posId)
      .then(positions => {
        if (!has([positionIndex], positions)) return [];
        return api.getValueMovement(
          {
            psSecNmb: positions[positionIndex].number,
            psActNmb: positions[positionIndex].number,
            psCcy: positions[positionIndex].currency,
            psRicCode: positions[positionIndex].ricCode,
            numberOfRows: 5,
          },
          metaData
        );
      })
      .then(map(parseValueMovement)));

  const getTransactions = memoizer()((portfolioId, positionIndex, metaData) =>
    getPositions(portfolioId, metaData)
      .then(positions => {
        if (!has([positionIndex], positions)) return [];
        return api.getTransactions(
          {
            posId: positions[positionIndex].secID,
          },
          metaData
        ).then(map(parseTransaction));
      }));

  return { getPositionsLength, getPositions, getValueMovement, getTransactions };
}

module.exports = serviceFactory;
